import Moment from 'moment'

export const formatDate = date => {
  if (date) {
    return Moment(date).local().format('MM/DD/YYYY')
  }

  return ''
}
